import { AgingMetric } from 'types';

import { api } from './api';

export interface AgingReport {
  [key: string]: AgingMetric;
}

export const agingDashboardAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getAging: build.query<AgingReport, string>({
      query: (group) => ({ url: `/aging?group=${group}` }),
      providesTags: (_result, _error, id) => [{ type: 'AgingGroup', id }],
    }),
  }),
});

export const { useGetAgingQuery } = agingDashboardAPI;
